import script from "./Forbidden.vue?vue&type=script&setup=true&lang=js"
export * from "./Forbidden.vue?vue&type=script&setup=true&lang=js"

import "./Forbidden.vue?vue&type=style&index=0&id=88ee66e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88ee66e4"]])

export default __exports__